module.exports = __webpack_public_path__ + "img/banner.185f4582.jpg";